<template>
  <div>
    <!-- Banner轮播 -->
    <div class="banner_wrapper">
      <home-banner class="top_banner" />
      <banner-logo />
    </div>


    <!-- 产品展示 -->
    <section class="home_products_section">
      <div class="container">
        <div class="section_header">
          <p class="h2">{{ $t("产品展示") }}</p>
          <router-link to="/Products" class="more_btn">{{ $t("查看更多") }} ></router-link>
        </div>

        <!-- 一级分类 -->
        <div class="category_tabs" v-if="productCategories.length > 0">
          <div
            class="category_item"
            v-for="(category, index) in productCategories"
            :key="category.id"
            :class="{ active: selectedCategory === index }"
            @click="selectCategory(index)"
          >
            <div class="category_icon">
              <img :src="category.image" :alt="category.name" />
            </div>
            <span class="category_name">{{ category.name }}</span>
          </div>
        </div>

        <!-- 产品列表 -->
        <div class="products_list">
          <div
            class="product_card"
            v-for="(product, index) in currentCategoryProducts"
            :key="index"
            @click="goToProductDetail(product.id)"
          >
            <div class="product_img">
              <img :src="product.image" :alt="product.name" />
            </div>
            <div class="product_info">
              <pre class="h2">{{ product.name }}</pre>
              <img src="../../static/img/查看产品详情箭头-未选中.png" class="arrow_icon" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="home_solutions_section" v-if="introData1" :style="{ 'background-image': `url(${introData1.bigImage})` }">
      <div class="container solutions_container">
        <div class="solutions_left">
          <p class="main_title">{{ introData1.bigTitle }}</p>
          <p class="sub_title">{{ introData1.subTitle1 }}</p>
        </div>
        <div class="solutions_right">
          <p class="intro_text">{{ introData1.introduction }}</p>
          <router-link to="/About" class="more_btn">{{ $t("更多") }} ></router-link>
        </div>
      </div>
    </div>
    <!-- 关于我们简介 -->
    <div class="home_about_section" v-if="introData2">
      <div class="container">
        <div class="about_content">
          <div class="about_text" :style="{ 'background-image': `url(${introData2.smallImage})` }">
            <div class="text_overlay">
              <div class="text_item">
                <img :src="introData2.icon1" class="icon_img" />
                <span>{{ introData2.subTitle1 }}</span>
              </div>
              <div class="text_item_line"></div>
              <div class="text_item">
                <img :src="introData2.icon2" class="icon_img" />
                <span>{{ introData2.subTitle2 }}</span>
              </div>
              <div class="text_item_line"></div>
              <div class="text_item">
                <img :src="introData2.icon3" class="icon_img" />
                <span>{{ introData2.subTitle3 }}</span>
              </div>
              <div class="text_item_line"></div>
              <div class="text_item">
                <img :src="introData2.icon4" class="icon_img" />
                <span>{{ introData2.subTitle4 }}</span>
              </div>
            </div>
          </div>
          <div class="about_image">
            <img :src="introData2.bigImage" class="about_img" />
          </div>
        </div>
      </div>
    </div>




    <!-- 新闻动态 -->
    <section class="home_news_section">
      <div class="container">
        <div class="section_header">
          <p class="h2">{{ $t("新闻资讯") }}</p>
          <router-link to="/News" class="more_btn">{{ $t("查看更多") }} ></router-link>
        </div>
        <el-row class="sub_news_div" :gutter="20">
          <el-col
              :md="24"
              v-for="(item, i) in homeNews.slice(0, 3)"
              :key="i"
          >
            <div
                class="news_sub_box"
                @click="goToNews(item.id)"
            >
              <div class="bottom_content">
                <div class="news_sub_time_wrapper">
                  <p class="news_sub_time_full">{{ item.day }}</p>
                  <p class="news_sub_time_short">{{ item.month }}</p>
                </div>
                <div class="news_sub_text">
                  <p class="news_sub_title double-line">
                    {{ item.title }}
                  </p>
                  <p class="news_sub_content double-line">
                    {{ item.summary }}
                  </p>
                </div>
              </div>
              <div class="top_div">
                <div class="img_div">
                  <img :src="item.img || item.image"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>
    </section>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import * as API from "@/api/index";
import HomeBanner from "./view/HomeBanner.vue";
import BannerLogo from "./view/BannerLogo.vue";
import HomeProductBanner from "./view/HomeProductBanner.vue";
import HomeProductBannerPhone from "./view/HomeProductBannerPhone.vue";
import ArcBg from "./view/ArcBg.vue";
import AccordionView from "./view/AccordionView.vue";
import AboutSwiper2 from "./view/AboutSwiper2.vue";
import AboutSwiper5 from "./view/AboutSwiper5.vue";
export default {
  data() {
    return {
      oldScrollTop: 0,
      numScrollStart: false,
      company: "",
      news: [],
      homemsg: [{ title: "", titleEn: "", midTitle: "", midTitleEn: "" }],
      imgs: [{ img: "" }],
      types: [{}, {}, {}, {}, {}, {}, {}],
      isMiniWindows: false,
      clientWidth: 0,
      selectedCategory: 0,
      productCategories: [],
      categoryProducts: {},
      introData1: null,
      introData2: null,
      solutions: [
        {
          title: "数据中心",
          desc: "高密度光纤布线解决方案",
          icon: "el-icon-s-data",
        },
        {
          title: "FTTx",
          desc: "光纤到户完整解决方案",
          icon: "el-icon-share",
        },
        {
          title: "定制服务",
          desc: "根据需求提供定制产品",
          icon: "el-icon-set-up",
        },
      ],
      homeNews: [
        {
          id: 1,
          day: "15",
          month: "2024.03",
          title: "公司荣获高新技术企业认定",
          summary: "经过严格评审，公司正式获得国家级高新技术企业认定...",
        },
        {
          id: 2,
          day: "08",
          month: "2024.03",
          title: "新品发布：MPO高密度光纤连接器",
          summary: "针对数据中心应用推出的新一代高密度光纤连接方案...",
        },
        {
          id: 3,
          day: "20",
          month: "2024.02",
          title: "参加2024年国际通信展",
          summary: "公司将携最新产品参加在深圳举办的国际通信展览会...",
        },
      ],
    };
  },
  components: {
    HomeBanner,
    BannerLogo,
    HomeProductBanner,
    HomeProductBannerPhone,
    ArcBg,
    AccordionView,
    AboutSwiper2,
    countTo,
    AboutSwiper5,
  },
  computed: {
    currentCategoryProducts() {
      return this.categoryProducts[this.selectedCategory] || [];
    },
  },
  watch: {
    clientWidth(newVal, oldVal) {
      // console.log(newVal); //浏览器窗口变化时，打印宽度。
      if (newVal < 1200) {
        this.isMiniWindows = true;
      } else {
        this.isMiniWindows = false;
      }
    },
    $route(to, from) {
      if (to.path == "/") {
        window.scrollTo(0, 0);
      }
    },
  },
  mounted() {
    this.Init();
    window.scrollTo(0, 0);
    let that = this;
    var clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },

  methods: {
    navto(path, param) {
      if (param) {
        this.$router.push({
          path: `${path}`,
          query: { param: param },
        });
      } else {
        this.$router.push(path);
      }
    },
    goToNews(id) {
      this.$router.push(`/NewsDetail/${id}`);
    },
    selectCategory(index) {
      this.selectedCategory = index;
      const categoryId = this.productCategories[index]?.id;
      if (categoryId && !this.categoryProducts[index]) {
        this.getProductsByCategory(categoryId);
      }
    },
    goToProductDetail(id) {
      this.$router.push(`/ProductsDetail/${id}`);
    },
    Init() {
      this.getHomeBannerData();
      this.getHomeIntroData();
      this.getProductCategories();
      this.getNewsCompanyData();
      // 监听页面滚动事件
      window.addEventListener("scroll", this.scrolling);
    },
    // 获取首页Banner
    getHomeBannerData() {
      API.getHomeBannerList({ page: 1, limit: 5 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list) {
            // 处理banner数据
            console.log('Home Banner:', res.page.list);
          }
        })
        .catch(() => {});
    },
    // 获取首页简介
    getHomeIntroData() {
      API.getHomeIntroList({ page: 1, limit: 2 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list) {
            const list = res.page.list;
            // 转换第一个简介数据
            if (list[0]) {
              this.introData1 = {
                ...list[0],
                bigTitle: this.$getI18nField(list[0], 'bigTitle'),
                subTitle1: this.$getI18nField(list[0], 'subTitle1'),
                introduction: this.$getI18nField(list[0], 'introduction')
              };
            }
            // 转换第二个简介数据
            if (list[1]) {
              this.introData2 = {
                ...list[1],
                subTitle1: this.$getI18nField(list[1], 'subTitle1'),
                subTitle2: this.$getI18nField(list[1], 'subTitle2'),
                subTitle3: this.$getI18nField(list[1], 'subTitle3'),
                subTitle4: this.$getI18nField(list[1], 'subTitle4')
              };
            }
          }
        })
        .catch(() => {});
    },
    // 获取产品一级分类
    getProductCategories() {
      API.getProductCategoryList({ page: 1, limit: 10 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list) {
            this.productCategories = res.page.list.map((item) => ({
              id: item.id,
              name: this.$getI18nField(item, 'title'),
              image: item.image || require("../../static/img/logo.png"),
            }));
            // 默认加载第一个分类的产品
            if (this.productCategories.length > 0) {
              this.getProductsByCategory(this.productCategories[0].id);
            }
          }
        })
        .catch(() => {});
    },
    // 根据分类ID获取产品列表
    getProductsByCategory(categoryId) {
      API.getProductListByCategory(categoryId)
        .then((res) => {
          if (res.code === 0 && res.list) {
            const products = res.list.map((item) => {
              const images = item.images ? JSON.parse(item.images) : [];
              return {
                id: item.id,
                name: this.$getI18nField(item, 'name').replace(";","\n"),
                image: images.length > 0 ? images[0] : require("../../static/img/logo.png"),
              };
            });
            // 存储到 categoryProducts 中，以 selectedCategory 索引为 key
            this.$set(this.categoryProducts, this.selectedCategory, products);
          }
        })
        .catch(() => {});
    },
    // 获取企业新闻
    getNewsCompanyData() {
      API.getNewsCompanyList({ page: 1, limit: 3 })
        .then((res) => {
          if (res.code === 0 && res.page && res.page.list) {
            this.homeNews = res.page.list.map(item => {
              const dateStr = item.publishDate || item.createTime;
              const date = dateStr ? new Date(dateStr) : new Date();
              return {
                id: item.id,
                day: date.getDate().toString().padStart(2, '0'),
                month: `${date.getFullYear()}.${(date.getMonth() + 1).toString().padStart(2, '0')}`,
                title: this.$getI18nField(item, 'title'),
                summary: this.$getI18nField(item, 'summary'),
                img: item.image || ''
              };
            });
          }
        })
        .catch(() => {});
    },
    //判断介绍部分是否出现，开始数字动画
    scrolling() {
      // 滚动条距文档顶部的距离（做兼容处理）===》不懂的可以结合画图理清逻辑
      let scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      // console.log("oldScrollTop==" + this.oldScrollTop);
      var clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      if (clientWidth < 1600) {
        if (this.oldScrollTop > 600) {
          this.handleScroll();
        }
      } else if (clientWidth < 1700) {
        if (this.oldScrollTop > 1200) {
          this.handleScroll();
        }
      } else {
        if (this.oldScrollTop > 1800) {
          this.handleScroll();
        }
      }
    },
    handleScroll() {
      if (!this.numScrollStart) {
        // this.$refs.mynum1.start();
        // this.$refs.mynum2.start();
        // this.$refs.mynum3.start();
      }
      this.numScrollStart = true;
    },
    getTypeList() {
      API.getProductType()
        .then((res) => {
          var status = res.code;
          if (status === 0) {
            this.types = res.data;
          }
        })
        .catch(() => {});
    },
  },
  created() {
    // window.addEventListener("onmessageWS", this.addAnimatedIn);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.scrolling);
  },
  updated() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// Banner容器
.banner_wrapper {
  position: relative;
}

// 首页各部分通用样式
.container {
  margin: 0 12.5%;
  padding: 0;
}

section {
  padding: 8rem 0;

  &.gray_bg {
    background: #f8f8f8;
  }
}

.section_header {
  align-items: center;
  text-align: center;
  margin-bottom: 5rem;
  display: flex;
  justify-content: space-between;

  .h2 {
    font-family: bold;
    font-size: 6rem;
    color: $color2C;
    margin: 0 0 1rem;
  }

  .subtitle {
    font-size: 1.8rem;
    color: $textBlueColor;
    letter-spacing: 0.5rem;
  }
}

.more_btn {
  font-family: regular;
  display: inline-block;
  padding: 0.5rem 1.5rem 0.2rem;
  color: #9CCF86;
  border-radius: 3rem;
  font-size: 1.6rem;
  transition: all 0.3s;
  text-align: center;
  height: fit-content;
  align-items: center;
  margin: auto 0;
  border: 1px solid #9CCF86;
  text-decoration: none;

  &:hover {
    background: #9CCF86;
    color: white;
  }

  &.outline {
    background: transparent;
    color: $textBlueColor;
    border: 1px solid $textBlueColor;

    &:hover {
      background: $textBlueColor;
      color: white;
    }
  }
}

.text_center {
  text-align: center;
  margin-top: 4rem;
}

// 关于我们部分
.home_about_section {
  width: 100%;
  height: auto;

  .container {
    margin: 0;
    padding: 0;
    max-width: none;
  }

  .about_content {
    display: flex;
    align-items: center;
    height: 60rem;
  }

  .about_text {
    width: 43.3%;
    height: 100%;
    background-color: #e0e0e0;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .text_overlay {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      width: 100%;
      margin-left: 24rem;

      .text_item_line{
        height: 1px;
        max-width: 50rem;
        background: #E7E8EA;
        margin: 2rem 0 1rem 0;
      }
      .text_item {
        display: flex;
        align-items: center;
        text-align: left;

        .icon_img {
          width: 4.6rem;
          height: 4.6rem;
          object-fit: contain;
          flex-shrink: 0;
        }

        i {
          font-size: 4.6rem;
          color: white;
          flex-shrink: 0;
        }

        span {
          font-family: regular;
          font-size: 2.2rem;
          color: white;
          margin-left: 4rem;
        }
      }
    }
  }

  .about_image {
    width: 56.7%;
    height: 100%;

    .about_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image_placeholder {
      height: 100%;
      background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 10rem;
        color: $textBlueColor;
        opacity: 0.5;
      }
    }
  }
}

// 产品部分
.home_products_section {
  .section_header.with_arrow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .title_left {
      .h2 {
        font-size: 3.6rem;
        color: $color2C;
        margin: 0;
      }
    }

    .view_all_link {
      display: flex;
      align-items: center;
      gap: 1rem;
      color: $textBlueColor;
      font-size: 1.6rem;
      text-decoration: none;
      transition: all 0.3s;

      &:hover {
        opacity: 0.8;
      }

      .arrow_icon {
        width: 2rem;
        height: auto;
      }
    }
  }

  // 分类标签
  .category_tabs {
    display: flex;
    justify-content: space-between;
    gap: 3rem;
    margin-bottom: 4rem;
    flex-wrap: wrap;
    border-bottom: 1px solid #B9B9B9;

    .category_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding-bottom: 1.5rem;
      border-bottom: 2px solid transparent;
      transition: all 0.3s;
      justify-content: flex-start;
      box-sizing: border-box;
      border-bottom:4px solid transparent;

      &.active {
        border-bottom:4px solid #1D2087;

        .category_name {
          color: #1D2087;
        }
      }

      &:hover {
        .category_name {
          color: #1D2087;
        }
      }

      .category_icon {
        width: 8rem;
        height: 8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.8rem;

        img {
          max-width: 8rem;
          max-height: 8rem;
          object-fit: contain;
        }
      }

      .category_name {
        font-family: regular;
        font-size: 1.6rem;
        color: #020202;
        text-align: center;
        max-width: 12rem;
        transition: all 0.3s;
      }
    }
  }

  // 产品列表
  .products_list {
    display: flex;
    gap: 3rem;
    overflow-x: auto;
    box-sizing: border-box;
    padding: 2px;

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #1D2087;
    }

    .product_card {
      flex: 0 0 calc((100% - 9rem) / 4);
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      box-sizing: border-box;

      &:hover {
        .product_img {
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
          border: 1px solid #1D2087;
        }
        //transform: translateY(-5px);

        .product_info .arrow_icon {
          content: url('../../static/img/查看产品详情箭头-选中.png');
        }
      }

      .product_img {
        height: 27rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 1px solid #BDC0C5;
        padding: 2rem;
        border-radius: 1rem;
        transition: all 0.3s;


        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          box-sizing: border-box;
        }
      }

      .product_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem 0;

        .h2 {
          font-family: regular;
          text-align: left;
          font-size: 2rem;
          color: #5B6370;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .arrow_icon {
          width: 1.8rem;
          margin-left:0.6rem;
          height: auto;
          transition: all 0.3s;
          content: url('../../static/img/查看产品详情箭头-未选中.png');
        }
      }
    }
  }
}

// 解决方案部分
.home_solutions_section {
  width: 100%;
  height: 67rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;

  .solutions_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 140rem;
    margin: 0 auto;
    padding: 0 10rem;
  }

  .solutions_left {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: 100%;

    .main_title {
      margin: 16.6rem 0 0;
      font-size: 12rem;
      color: #E7E8EA;
      font-weight: bold;
      line-height: 1;
    }

    .sub_title {
      font-size: 6rem;
      color: #212121;
      margin: 0;
      font-family: bold;
      line-height: 1;
    }
  }

  .solutions_right {
    height: 100%;
    max-width: 57rem;
    text-align: left;
    position: relative;

    .intro_text {
      font-family: regular;
      margin: 27rem 0 0;
      font-size: 2.2rem;
      color: #5B6370;
      line-height: 3rem;
    }

    .more_btn {
      font-family: regular;
      position: absolute;
      bottom: 24rem;
      right: 0;
      display: inline-block;
      padding: 0.5rem 1.5rem 0.2rem;
      background: transparent;
      color: #9CCF86;
      border: 2px solid #9CCF86;
      border-radius: 3rem;
      font-size: 1.6rem;
      text-decoration: none;
      transition: all 0.3s;
      line-height: 1;

      &:hover {
        background: #9CCF86;
        color: white;
      }
    }
  }
}

// 新闻部分
.home_news_section {
  .sub_news_div {
    padding-left:18%;
    .el-col {
      margin-bottom: 2rem;
    }
  }

  .news_sub_box {
    cursor: pointer;
    background-color: white;
    transition: all 0.3s;
    margin-bottom: 6rem;
    display: flex;

    &:hover {
      .news_sub_time_full,
      .news_sub_title {
        color: #9CCF86;
      }

      .bottom_content {
        .news_sub_title {
          color: $textMainColor;
        }
      }
    }

    .bottom_content {
      width: 70%;
      padding: 0;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #656565;

      p {
        text-align: start;
      }
    }

    .top_div {
      width: 30%;
      transition: all 0.5s;
      height: 17rem;
      background-color: white;
      display: flex;
      justify-content: flex-end;
    }

    .img_div {
      overflow: hidden;
      width: 26rem;
      height: 100%;
      border-radius: 1.6rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.5s;
      }
    }

    .news_sub_time_wrapper {
      display: flex;
      flex-direction: column;
      margin-bottom: 4.5rem;
      width: auto;
      justify-content: flex-end;
    }

    .news_sub_time_full {
      font-size: 5.5rem;
      color: #5B6370;
      margin: 0;
      transition: color 0.3s;
      font-family: 'regular';
    }

    .news_sub_time_short {
      font-size: 1.8rem;
      color: #5B6370;
      margin: 0;
      font-family: 'regular';
    }

    .news_sub_text {
      max-width: 70%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-left: 6rem;
      margin-bottom: 4.5rem;

      .news_sub_title {
        font-size: 3.2rem;
        line-height: 4.5rem;
        font-family: bold;
        color: #5B6370;
        margin: 0 0 1.2rem 0;
        transition: color 0.3s;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .news_sub_content {
        font-size: 2.2rem;
        margin-bottom: 0;
        line-height: 3rem;
        color: #5B6370;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: regular;
      }
    }

    .double-line {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

// CTA部分
.home_cta_section {
  background: linear-gradient(135deg, $textBlueColor 0%, darken($textBlueColor, 15%) 100%);
  text-align: center;

  .h2 {
    font-size: 3.6rem;
    color: white;
    margin: 0 0 1.5rem;
  }

  p {
    font-size: 1.8rem;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 3rem;
  }

  .cta_btn {
    display: inline-block;
    padding: 1.5rem 5rem;
    background: white;
    color: $textBlueColor;
    border-radius: 5rem;
    font-size: 1.8rem;
    font-weight: bold;
    transition: all 0.3s;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }
  }
}

@media screen and (max-width: 1200px) {
  section {
    padding: 4rem 0;
  }

  .section_header {
    .h2 {
      font-size: 2.8rem;
    }

    .subtitle {
      font-size: 1.4rem;
    }
  }

  .home_about_section {
    .about_content {
      flex-direction: column;
      gap: 3rem;
    }

    .about_image {
      width: 100%;

      .image_placeholder {
        height: 25rem;

        i {
          font-size: 6rem;
        }
      }
    }
  }

  .home_products_section {
    .section_header.with_arrow {
      .title_left {
        .h2 {
          font-size: 2.8rem;
        }
      }

      .view_all_link {
        font-size: 1.4rem;
      }
    }

    .category_tabs {
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      gap: 2rem;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 1rem;
      border-bottom: none;

      &::-webkit-scrollbar {
        height: 0.6rem;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 1rem;
      }

      &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 1rem;
      }

      .category_item {
        flex: 0 0 auto;
        min-width: 10rem;
        padding-bottom: 2rem;

        .category_icon {
          width: 6rem;
          height: 6rem;

          img {
            max-width: 6rem;
            max-height: 6rem;
          }
        }

        .category_name {
          font-size: 1.4rem;
          max-width: 10rem;
        }
      }
    }

    .products_list {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      gap: 2rem;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 1rem;

      &::-webkit-scrollbar {
        height: 0.6rem;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 1rem;
      }

      &::-webkit-scrollbar-thumb {
        background: #1D2087;
        border-radius: 1rem;
      }

      .product_card {
        flex: 0 0 28rem;
        min-width: 28rem;

        .product_img {
          height: 16rem;
          padding: 1.5rem;
        }

        .product_info {
          padding: 1.2rem 0;

          .h2 {
            font-size: 1.6rem;
          }

          .arrow_icon {
            width: 1.8rem;
          }
        }
      }
    }
  }

  .home_solutions_section {
    .solutions_grid {
      grid-template-columns: 1fr;
    }
  }

  .home_news_section {
    .news_sub_box {
      margin-top: 2rem;

      .top_div {
        height: 22.8rem;
      }

      .img_div {
        height: 22.8rem;

        img {
          height: 100%;
        }
      }

      .bottom_content {
        margin: 0;
        padding: 1rem 0;

        .news_sub_title {
          margin: 0;
          font-size: 1.5rem;
          line-height: 1.9rem;
        }

        .news_sub_content {
          font-size: 1.1rem;
          line-height: 1.7rem;
          margin: 0.6rem 0 1.8rem;
        }

        .news_sub_time {
          font-size: 1rem;
        }
      }
    }
  }

  .home_cta_section {
    .h2 {
      font-size: 2.4rem;
    }

    p {
      font-size: 1.6rem;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    margin: 0 2rem;
    padding: 0;
  }

  section {
    padding: 4rem 0;
  }

  .section_header {
    margin-bottom: 3rem;
    display: flex;

    .h2 {
      font-size: 3rem;
      margin: 0;
      flex: 1;
      text-align: left;
    }
  }

  .more_btn {
    margin: 0;
    padding: 0.4rem 1.2rem 0.2rem;
    font-size: 1.4rem;
    width: fit-content;
  }

  .home_about_section {
    .about_content {
      display: flex;
      flex-direction: column-reverse;
      height: auto;
      gap: 0;
    }

    .about_text {
      width: 100%;
      padding: 3rem 2rem;
      box-sizing: border-box;

      .text_overlay {
        margin-left: 0;
        gap: 1.5rem;

        .text_item {
          display: flex;

          .icon_img {
            width: 3rem;
            height: 3rem;
          }

          span {
            font-size: 1.6rem;
            margin-left: 2rem;
          }
        }

        .text_item_line {
          margin: 1rem 0 0.5rem 0;
        }
      }
    }
  }

  .home_products_section {
    .category_tabs {
      gap: 1.5rem;

      .category_item {
        flex: 0 0 auto;
        min-width: 9rem;
        padding-bottom: 2rem;

        .category_icon {
          width: 5rem;
          height: 5rem;

          img {
            max-width: 5rem;
            max-height: 5rem;
          }
        }

        .category_name {
          font-size: 1.4rem;
          max-width: 9rem;
        }
      }
    }

    .products_list {
      display: flex;
      gap: 1.5rem;

      .product_card {
        flex: 0 0 25rem;
        min-width: 25rem;

        .product_img {
          height: 14rem;
          padding: 1.5rem;
        }

        .product_info {
          padding: 1rem 0;

          .h2 {
            font-size: 1.5rem;
          }

          .arrow_icon {
            width: 1.6rem;
          }
        }
      }
    }
  }

  .home_solutions_section {
    height: 35rem;
    padding: 4rem 0;

    .solutions_container {
      padding: 0 2rem;
      display: flex;
      flex-direction: column;

    }

    .solutions_left {
      width: 100%;
      .main_title {
        font-size: 6rem;
        margin: 0;
      }

      .sub_title {
        font-size: 3rem;
      }
    }

    .solutions_right {
      width: 100%;
      .intro_text {
        font-size: 1.6rem;
        line-height: 1.5;
        margin: 0;
      }

      .more_btn {
        bottom: 5rem;
      }
    }
  }

  .home_news_section {
    .sub_news_div {
      padding-left: 0;
    }

    .news_sub_box {
      margin-bottom: 3rem;
      display: flex;
      justify-content: space-between !important;

      .bottom_content {
        display: flex;
        width: 60% !important;

        .news_sub_time_wrapper {
          margin-bottom: 0 !important;
          justify-content: center;
        }

        .news_sub_time_full {
          font-size: 2.8rem;
        }

        .news_sub_time_short {
          font-size: 0.9rem;
        }

        .news_sub_text {
          margin-left: 2rem;
          margin-bottom: 0;
          justify-content: center;

          .news_sub_title {
            font-size: 2rem;
            line-height: 2.8rem;
            margin: 0 0 0.8rem 0;
          }

          .news_sub_content {
            font-size: 1.6rem;
            line-height: 2.2rem;
            margin: 0;
          }
        }
      }

      .top_div {
        width: 35%;
        height: 8rem !important;
      }

      .img_div {
        width: 100% !important;
        height: 100% !important;
        border-radius: 1rem;
      }

      .img_div {
        width: 20rem;
        height: 15rem;
      }
    }
  }
}
</style>
